import { HttpClient } from "@angular/common/http";
import { Injectable, OnInit } from "@angular/core";
import { ProductAllocation } from "../model/product-allocation";

@Injectable()
export class AllocationsService {

    _backendUrl: string

    constructor(private http: HttpClient) {
        this._backendUrl = localStorage.getItem("backendURL");
    }

    public getAllocations() {
        return this.http
            .get<ProductAllocation[]>(this._backendUrl + `allocations`)
    }

    public putAllocation(allocation: ProductAllocation) {
        return this.http
            .put<ProductAllocation[]>(this._backendUrl + `allocations`, allocation)
    }

    public deleteAllocation(allocation: ProductAllocation) { 
        return this.http
            .delete<any>(this._backendUrl + `allocations/${allocation.structureId}/${allocation.product.id}`, )
    }
}


// WEBPACK FOOTER //
// ./src/app/+core/common/services/allocations.service.ts